export enum PaymentMethodStatus {
  PENDING_CUSTOMER_APPROVAL = 'PENDING_CUSTOMER_APPROVAL',
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
}

export enum PaymentMethodType {
  CARD = 'CARD',
  BACS_DEBIT = 'BACS_DEBIT',
}

export interface PaymentMethod {
  accountCode?: string
  mandateId: string
  reference: string
  status: PaymentMethodStatus
  bankAccountNumberEnding: string
  bankName: string
  type: PaymentMethodType
}
